import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { UBICACIONESALMACENAMIENTO_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function UbicacionesAlmacenamientoPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${UBICACIONESALMACENAMIENTO_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
